<template>
    <div style='width:100%;height:100%;background-color:#EEE;'>

        <template v-if="loading == true">
            <div class='w100 text-center'>
                <div style="height:20vh;"></div>
                <loader-inline/>
            </div>
        </template>
        <template v-else>

          <template v-if="publicSessionModeProgramNotPublished">

            <div style="height:20vh;"></div>
            <div class="card text-center shadow" style="margin-left:20vh;margin-right:20vh;">
              <div class="card-body">
                <img :src="'/assets/images/in_construction.png'" style="width:150px;">
                <h5 class="card-title color-primary pt-4">La configuration de votre logement n'est pas encore disponible.</h5>
                <p class="card-text"></p>
              </div>
            </div>
          </template>

            <template v-if="publicSessionModeProgramNotPublished">

                <div style="height:20vh;"></div>
                <div class="card text-center shadow" style="margin-left:20vh;margin-right:20vh;">
                    <div class="card-body">
                        <img :src="'/assets/images/in_construction.png'" style="width:150px;">
                        <h5 class="card-title color-primary pt-4">La configuration de votre logement n'est pas encore disponible.</h5>
                        <p class="card-text"></p>
                    </div>
                </div>
            </template>

            <template v-if="privateSessionModeOrForbiddenUnityApp">
                <div style="height:20vh;"></div>
                <div class="card text-left shadow" style="margin-left:20vh;margin-right:20vh;">
                    <div class="card-body">
                        <div class="d-flex text-primary mb-5">
                            <i class="fa fa-exclamation-triangle fa-3x me-3" aria-hidden="true"></i>
                            <h2>Vous ne pouvez pas lancer cette session.</h2>
                        </div>
                    </div>
                </div>
            </template>

          <template v-if="homeplanSaveExist">
            <div style="height:20vh;"></div>
            <div class="card text-left shadow" style="margin-left:20vh;margin-right:20vh;">
              <div class="card-body">
                <div class="d-flex text-primary mb-5">
                  <i class="fa fa-exclamation-triangle fa-3x me-3" aria-hidden="true"></i>
                  <h2>Vous ne pouvez pas lancer cette session car une sauvegarde Homeplan existe déjà.</h2>
                </div>
              </div>
            </div>
          </template>

            <template v-if="unityAppMaintenance != null">

                <div style="height:20vh;"></div>
                <div class="card text-left shadow" style="margin-left:20vh;margin-right:20vh;">
                    <div class="card-body">
                        <div class="d-flex text-primary mb-5">
                            <i class="fa fa-info-circle fa-3x me-3" aria-hidden="true"></i>
                            <h2>La maquette 3D de votre logement est actuellement en maintenance.</h2>
                        </div>

                        <div class="mt-5 mb-5 text-xl" style="font-size:1.4em;">
                            <b>Détails : </b><span class="text-muted">{{ unityAppMaintenance.reason }}</span><br />
                        </div>
                    </div>
                </div>

            </template>

            <template v-if="unknownError">

                <div style="height:20vh;"></div>
                <div class="card text-left shadow" style="margin-left:20vh;margin-right:20vh;">
                    <div class="card-body">
                        <div class="d-flex text-primary mb-5">
                            <i class="fa fa-exclamation-triangle fa-3x me-3" aria-hidden="true"></i>
                            <h2>Une erreur inattendue s'est produite.</h2>
                        </div>
                    </div>
                </div>

            </template>

            <template v-if="!publicSessionModeProgramNotPublished && !privateSessionModeOrForbiddenUnityApp && unityAppMaintenance == null && !homeplanSaveExist && !unknownError">

                <template v-if="sessionLink != null">
                    <iframe class="sgxiframe" :class="{ 'withCgv' : cgv_link != null }" :src="sessionLink"/>
                    <div class='cgv' v-if="cgv_link != null">
                        <a :href="cgv_link" target="_blank">
                            Conditions générales de vente.
                        </a>
                    </div>

                    <template v-if="uploadForm">
                        <session-file-uploader ref="fileUploader" :session-id="sessionId" :params="uploadParams" :company-code="companyCode"/>
                    </template>

                </template>

                <template v-else-if="homeplanSaveId != null && updateToken != null" >
                    <homeplan-wrapper
                        :homeplan-base-url="homeplanBaseUrl"
                        :homeplan-access-point="homeplanAccessPoint"
                        :homeplan-save-id="homeplanSaveId"
                        :update-token="updateToken"/>
                </template>

                <template v-else-if="layouts != null">
                    <div class="layout-selector p-5">
                        <div class="container">
                            <h3 class="my-5">Aménagement de votre logement : choisissez le plan qui vous correspond</h3>

                            <div class="row">
                                <template v-for="layout in layouts">
                                    <div class="col-lg-4">
                                        <a class='card card-xs card-layout' :href="currentUrl + '/' + layout.id">
                                            <div class='card-body'>
                                                <div class='container-fluid'>
                                                    <div class='row'>
                                                        <div class='col-12 text-center'>
                                                            <h5 class='h-100'>
                                                                {{ layout.name }}
                                                            </h5>
                                                        </div>
                                                        <div class='col-12 my-3 text-center'>
                                                            <img :src="'/assets/images/no_image.png'" class="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </template>

        </template>
    </div>
</template>

<script>
import loaderInline from "../common/loader/loader.inline.vue";
import SessionFileUploader from "./session.file.uploader.vue";
import HomeplanWrapper from "./homeplan.wrapper.vue";

export default {
    components: {HomeplanWrapper, SessionFileUploader, loaderInline},
    props: {
        externalSessionLink: { type: String, required: false, default : null },
        homeplanBaseUrl: { type: String, required: true},
        homeplanAccessPoint: { type: String, required: true},
        companyCode: {type: String, required: true},
        sessionModeCode: {type: String, required: true},
        lotCodeOrUuid: {type: String, required: true},
        lotLayoutId: {type: String, required: true},
        lotVersionId: {type: String, required: true},
    },
    data: function () {
        return {
            currentUrl: window.location.href,
            loading: true,
            sessionId: null,
            sessionLink: null,
            homeplanSaveId: null,
            updateToken: null,
            unityAppMaintenance: null,
            unknownError:null,
            layouts: null,
            cgv_link: null,
            uploadForm: false,
            uploadParams: {},
            publicSessionModeProgramNotPublished: false,
            privateSessionModeOrForbiddenUnityApp : false,
        }
    },
    mounted: function () {
        window.addEventListener('message', this.pipelineReceive);

        axios.all([
            axios.post('/api/v1/cloud/route', {
                external_session_link: this.externalSessionLink,
                company_code: this.companyCode,
                session_mode_code: this.sessionModeCode,
                lot_code_or_uuid: this.lotCodeOrUuid,
                lot_layout_id: this.lotLayoutId,
                lot_version_id: this.lotVersionId,
            }),
        ])
            .then(axios.spread((responseCoreSession) => {
                this.sessionId = responseCoreSession.data.data.session_id;
                this.sessionLink = responseCoreSession.data.data.session_link;
                this.homeplanSaveId = responseCoreSession.data.data.homeplan_save_id;
                this.updateToken = responseCoreSession.data.data.update_token;
                this.unityAppMaintenance = responseCoreSession.data.data.maintenance;
                this.cgv_link = responseCoreSession.data.data.cgv_link == "" ? null : responseCoreSession.data.data.cgv_link;
                this.loading = false;

                if (!this.unityAppMaintenance && this.sessionId != null && !this.publicSessionModeProgramNotPublished && !this.privateSessionModeOrForbiddenUnityApp) {
                    // ask core to generate cache
                    axios.all([
                        axios.post('/api/v1/cloud/cache', {sessionId: this.sessionId, companyCode : this.companyCode}),
                    ]).then(axios.spread((responseSessionCache) => {
                        console.log('Session cache generated');
                    }));
                }


            })).catch(error => {
              console.log(error.response);
            if (error.response.data.data.layouts != undefined) {// known error : lot has more than one layouts : display thems{
                this.layouts = error.response.data.data.layouts;
                this.loading = false;
            } else if (error.response.data.code == 403 && (error.response.data.message == "program_not_published_and_public_session_mode" || error.response.data.message == "not_available_in_configuration") ) {
                this.publicSessionModeProgramNotPublished = true;
                this.loading = false;
            } else if (error.response.data.code == 403 && error.response.data.message == "private_session_mode_or_forbidden_unity_application") {
                this.privateSessionModeOrForbiddenUnityApp = true;
                this.loading = false;
            } else if (error.response.data.code == 403 && error.response.data.message == "homeplan_save_exist") {
                this.homeplanSaveExist = true;
                this.loading = false;
            } else { // unknown error
                this.unknownError = true;
                this.loading = false;
                this.$httpError({error: error});
            }
        });

    },
    methods: {
        pipelineReceive: function (event) {
            if (event.data.data != undefined && event.data.data.r3d_pipeline_action != undefined) {
                let action = event.data.data.r3d_pipeline_action;
                let content = event.data.data.data;


                switch (action) {
                    case 'ask_for_upload':
                        this.uploadParams = content;
                        this.uploadForm = true;
                        break;
                    case 'close_upload':
                        this.$refs.fileUploader.cancelOverlay(content.uuid);
                        this.uploadForm = false;
                        this.uploadParams = {};
                        break;
                    default :
                        console.log("Pipeline from SGX : " + action);
                        console.log(content);
                        break;
                }
            }
        }
    },
    computed: {},
}
</script>

<style scoped>
.layout-selector {
    width: 100%;
    height: 100%;
    background-color: #f7efe7;
}

.layout-selector h3 {
    color: var(--sidebar-bg);
}

.card-layout {
    background-color: #DCE0E6;
}

.card-layout h5 {
    color: var(--custom-bs-primary);
    transition: all 0.3s ease;
}

.card-layout:hover {
    background-color: var(--sidebar-bg);
}

.card-layout:hover h5 {
    color: white;
}

.card-layout img {
    width: 100%;
    border-radius: var(--border-radius);
}

.sgxiframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0px;
    margin: 0px;
    padding: 0px;
    border: none;
}

.sgxiframe.withCgv {
    height: calc(100% - 20px);
}

.cgv {
    position: fixed;
    height: 20px;
    line-height: 18px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    border: none;
    bottom: 0px;
    left: 0px;
    text-align: right;
    padding-right: 5px;
    font-size: 14px;
}

@media screen and (max-height: 300px) {
    .sgxiframe.withCgv {
        height: calc(100% - 10px);
    }

    .cgv {
        height: 10px;
        line-height: 8px;
        font-size: 10px;
        text-align: center;
    }
}
</style>
